import Tooltip from "@mui/material/Tooltip"
import { Cup } from "../models/cup"

interface CupProps {
  cup: Cup
  height: string
}

export default function CupEmblem(props: CupProps) {
  const { cup, height } = props

  return (
    <Tooltip title={cup.name + " Cup"} placement="right">
      <span>
        <img
          src={require("../assets/cups/" + cup.icon + ".png")}
          alt={cup.name + " Cup"}
          height={height}
          style={{
            filter: "drop-shadow(0px 0px 3px rgba(127, 127, 127, 0.5))",
          }}
        />
      </span>
    </Tooltip>
  )
}
